module.exports = __webpack_public_path__ + "img/appobyte-logo-white.dc35f0de.png";